export default "__VITE_ASSET__5cda35bc__"